import { addDays, nextSaturday, nextSunday, format, isToday, isTomorrow, isSaturday, isSunday } from 'date-fns';
import { sv } from 'date-fns/locale';

export interface QuickDateOption {
  label: string;
  date: Date;
}

/**
 * Returns quick-date options relative to now (Europe/Stockholm local).
 * Always includes: Idag, I morgon, Nästa lördag, Nästa söndag.
 * If today IS Saturday or Sunday, the "Nästa" variant skips to next week.
 */
export function getQuickDateOptions(now = new Date()): QuickDateOption[] {
  const today = now;
  const tomorrow = addDays(today, 1);

  // nextSaturday/nextSunday from date-fns return the *next* occurrence
  // (not including today). If today is Saturday, nextSaturday returns next week.
  const sat = isSaturday(today) ? addDays(today, 7) : nextSaturday(today);
  const sun = isSunday(today) ? addDays(today, 7) : nextSunday(today);

  const options: QuickDateOption[] = [
    { label: 'Idag', date: today },
    { label: 'I morgon', date: tomorrow },
  ];

  // Don't duplicate if sat/sun is today or tomorrow
  if (!isToday(sat) && !isTomorrow(sat)) {
    options.push({
      label: `Lördag ${format(sat, 'd MMM', { locale: sv })}`,
      date: sat,
    });
  }

  if (!isToday(sun) && !isTomorrow(sun)) {
    options.push({
      label: `Söndag ${format(sun, 'd MMM', { locale: sv })}`,
      date: sun,
    });
  }

  return options;
}

/** Format a Date to the yyyy-MM-dd string used by the event form. */
export function toFormDateStr(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
